import React, {Component} from 'react';
import OwlCarousel from 'react-owl-carousel';
import { motion } from 'framer-motion';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
 

class Slider extends React.Component{

    constructor(props){
        super(props);
       
        this.state = { 
            loading:0
        }
 
    }

    componentDidMount()
    {   
         
       this.setState({loading:1}); 
         
    }
     
     
  render() {
    
    const options = {
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: true,
      nav: false,
      dots: true,
      animateOut: 'fadeOut',
      smartSpeed: 700,
      responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 },
      },
    };

    const titleVariant = {
      hidden: { opacity: 0, y: 20, scale: 0.98 },
      visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    const subtitleVariant = {
      hidden: { opacity: 0, y: 10 },
      visible: { opacity: 1, y: 0, transition: { delay: 0.15, duration: 0.6 } },
    };

    const ctaVariant = {
      hidden: { opacity: 0, scale: 0.95 },
      visible: { opacity: 1, scale: 1, transition: { delay: 0.35, duration: 0.45 } },
    };
if (this.state.loading === 0) {
            return <div>Loading...</div>;
          } 
    return ( 
      <div style={{ width: '100%' }}>
        <OwlCarousel className="owl-theme" {...options}>
          {this.props.banners.map((s, idx) => {
            // If s.img is a require() result or a string URL it's okay.
            // If you have local relative strings, do: s.img = require('path/to/img.jpg')
            return (
              <div
                key={s.id || idx}
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '80vh', // fallback height if you don't use Tailwind
                  minHeight: '350px',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* Actual image element */}
                <img
                  src={s.image}
                  alt={s.title || `slide-${idx}`}
                  style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                    // optional: make image slightly dim so white text is visible
                    filter: 'brightness(0.75)',
                  }}
                  onError={(e) => {
                    // show a fallback or log
                    e.currentTarget.style.display = 'none';
                    console.warn('Slider image failed to load:', s.img || s.bg);
                  }}
                />

                {/* overlay gradient */}
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.35) 100%)',
                    pointerEvents: 'none',
                  }}
                />

                {/* content */}
                <div style={{ position: 'relative', zIndex: 4, maxWidth: 1100, padding: '0 24px', textAlign: 'center', color: '#fff' }}>
                  <motion.h2 initial="hidden" animate="visible" variants={titleVariant} style={{ fontSize: '3rem', fontWeight: 800, lineHeight: 1.05 , textTransform:'uppercase', color:'#f05b29'}}>
                    {s.title}
                  </motion.h2>

                  <motion.p initial="hidden" animate="visible" variants={subtitleVariant} style={{ marginTop: 12, fontSize: '3rem', opacity: 0.95 , textTransform:'uppercase'}}>
                    {s.subtitle}
                  </motion.p>
 
                </div>
 
              </div>
            );
          })}
        </OwlCarousel>
      </div>
    );
  }
}

export default Slider;